"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInnerButton = exports.NonVisualButton = exports.LeftBorderWrapper = exports.InnerButton = exports.ButtonWrapper = void 0;
var _button = require("@react-aria/button");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _focus = require("@react-aria/focus");
var _button2 = require("./button.tokens");
var _input = require("../../inputs/input/input.tokens");
var _jsxRuntime = require("react/jsx-runtime");
/* Building blocks for rendering aria compatible buttons that do not render any content. Useful inside other components that control the styling, like the search bar.*/
var ButtonWrapper = exports.ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "InnerButton__ButtonWrapper",
  componentId: "sc-xq7zqa-0"
})(["display:flex;"]);
var LeftBorderWrapper = exports.LeftBorderWrapper = _styledComponents.default.div.withConfig({
  displayName: "InnerButton__LeftBorderWrapper",
  componentId: "sc-xq7zqa-1"
})(["display:flex;height:", ";padding:", ";border-left:", ";"], function (props) {
  return _input.tokens.size.height[props.size];
}, function (props) {
  return props.hasError ? '2px 0px' : '1px 0px';
}, _input.tokens.border.default);
var StyledInnerButton = exports.StyledInnerButton = _styledComponents.default.button.withConfig({
  displayName: "InnerButton__StyledInnerButton",
  componentId: "sc-xq7zqa-2"
})(["display:flex;justify-content:center;align-items:center;padding:0;background-color:inherit;border:0 solid transparent;cursor:pointer;width:", ";height:", ";border-radius:0 ", " ", " 0;width:", ";&:hover{background-color:", ";inset:1px;box-sizing:padding-box;color:", ";svg{path{fill:", ";}}}&.button-focus-ring{border:2px solid ", ";outline-style:none;}"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.height ? props.height : '100%';
}, _input.tokens.borderRadius, _input.tokens.borderRadius, function (_ref) {
  var sizeKey = _ref.sizeKey;
  return _input.tokens.size.height[sizeKey];
}, function (props) {
  return props.emphasis && (0, _button2.buttonTokens)(props.theme).color.background[props.emphasis].hover;
}, function (props) {
  return props.emphasis && (0, _button2.buttonTokens)(props.theme).color.font[props.emphasis].hover;
}, function (props) {
  return props.emphasis && (0, _button2.buttonTokens)(props.theme).color.icon[props.emphasis].hover;
}, function (props) {
  return props.theme.sys.color.border.focusring;
});
var NonVisualButton = exports.NonVisualButton = _styledComponents.default.button.withConfig({
  displayName: "InnerButton__NonVisualButton",
  componentId: "sc-xq7zqa-3"
})(["padding:0;background-color:inherit;border:none;height:100%;&:focus-visible{outline-style:none;div{border-radius:2px;", ";}}"], function (props) {
  return (0, _button2.buttonTokens)(props.theme).focusRing.default;
});
var InnerButton = exports.InnerButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var internalRef = (0, _react.useRef)();
  var theRef = ref || props.buttonRef || internalRef;
  var _ref2 = (0, _button.useButton)(props, ref),
    buttonProps = _ref2.buttonProps;
  var children = props.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
      focusRingClass: 'button-focus-ring',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledInnerButton, _objectSpread({}, buttonProps, props, {
        width: props.width,
        height: props.height,
        emphasis: props.emphasis,
        ref: theRef,
        children: children
      }))
    })
  });
});